import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Header from '../../common/header';
import Footer from '../../common/footer';
import s from './index.module.scss';
import i18next from 'i18next';
import mapStateToProps from '../../redux/util';
import {connect} from 'react-redux';


class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false,
    };
  }

  componentDidMount() {
    console.log(this.props, 'props in Home');
    this.getLoginInfo();
  }

  //获取登录信息
  getLoginInfo() {
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '';
    if (userInfo && userInfo.display_name) {
      this.setState({
        isLogin: true,
      });
    }
  }

  render() {
    return (<div className={ s.container }>
        <Header props={ this.props }/>
        <div className={ s.main_container }>
          <div className={ s.developer }>
            { i18next.t('home_title') }
          </div>
          <div className={ s.feeling }>
            { i18next.t('do_yourself') }
          </div>
          <div className={ s.solution }>
            { i18next.t('deep_customize') }
          </div>
          { this.state.isLogin ? <div className={ s.start }><Link to={ `/main` }>
            { i18next.t('checkout_docs') }
          </Link></div> : <div className={ s.start }>
            <Link to={ `/main` }>
              { i18next.t('start') }
            </Link>
          </div> }
          <div className={ s.character }>
            <div className={ s.item_box }>
              <div className={ s.instruction }/>
              <div className={ s.desc }>
                { i18next.t('instruction') }
              </div>
            </div>
            <div className={ s.item_box }>
              <div className={ s.OAuth }/>
              <div className={ s.desc }>
                { i18next.t('OAuth') }
              </div>
            </div>
            <div className={ s.item_box }>
              <div className={ s.open_interface }/>
              <div className={ s.desc }>
                { i18next.t('open_interface') }
              </div>
            </div>
            <div className={ s.item_box }>
              <div className={ s.data_push }/>
              <div className={ s.desc }>
                { i18next.t('data_push') }
              </div>
            </div>
          </div>
        </div>
        <div className={ s.fixFooter }>
          <Footer/>
        </div>
      </div>);
  }
}

export default connect(mapStateToProps, null)(Home);

